<template>
   <div id="rent-a-car-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div id="rent-a-car-search-wrapper">
            <!-- {{ filters }} -->

            <div class="row gx-3 gx-md-2 gx-lg-3 gx-xxl-3">
               <div id="rent-a-car-filter-column" class="col-md-1 col-lg d-none d-xxl-block">
                  <!-- FlightSearch Filters -->

                  <RentACarFilters :data="Cars" v-if="response?.result.success" @filters="handlerFilters" :supplier="response.suppliers" />
               </div>
               <div class="col-lg-12 col-xl-10 col-xxl-9">
                  <!-- Common Search Tab -->
                  <SearchTab :active-tab="4" @search-response="handlerSearchResponse" />

                  <!-- FlightSearch Resul t-->
                  <!-- {{ Cars }} -->
                  <!-- {{ selection }} -->
                  <!-- {{ response }} -->
                  <div class="rent-a-car-sort" v-if="response?.result.success">
                     <span class="sorting-informations">{{ Cars?.length || 0 }} {{ $t("rentacarSearch_carsListed") }}</span>
                     <div class="sorting-wrapper">
                        <UISelectBox :options="sortOptions" v-model="sortBy" lighter />
                     </div>
                  </div>
                  <div class="rent-a-card-wrapper mt-5">
                     <template v-for="(car, index) in Cars">
                        <RentACard
                           :key="index"
                           :car="car"
                           :search-uuid="response.searchUuid"
                           @selection="handlerSelection"
                           ref="carLists"
                           :currency="currency"
                           :show-debugger="showDebugger"
                           :supplier="response.suppliers[car.pickUpSupplierCode]" />
                     </template>
                  </div>
               </div>
               <div class="col-md-1 col-lg d-xl-block">
                  <!-- FlightBasket -->
                  <transition name="fade" mode="out-in">
                     <RentACarBasket :basket="selection" v-if="selection && isBasketActive" :currency="currency" :providerName="selection.vehicle.implementationType == 301 ? 'pandora' : 'cizgi'" />
                  </transition>
                  <!-- <button @click="handlerCheckout">checkout</button> -->
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
// import { rentacarService } from "@/service/index.js";
// import { generateUuid } from "@/utils.js";

import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";

import SearchTab from "@/components/unitary/SearchTab.vue";

import RentACarFilters from "@/components/structural/rentacar/RentACarFilters.vue";
import RentACard from "@/components/structural/rentacar/search/RentACarCard.vue";

import RentACarBasket from "@/components/structural/rentacar/search/RentACarBasket.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";

// import RentACarDummy from "@/pages/rentacar/RentACarDummy.js";

export default {
   name: "RentaCarSearch",
   components: {
      Aside,
      Navbar,
      Main,
      SearchTab,
      RentACarFilters,
      RentACard,
      RentACarBasket,
      UISelectBox,
   },
   data() {
      return {
         response: null,
         filters: null,
         selection: null,
         isBasketActive: false,
         showDebugger: false,
         sortBy: "priceAsc",
      };
   },
   created() {
      const self = this;
      document.body.addEventListener("keydown", (event) => {
         //debugger new version
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 73) {
            self.showDebugger = !self.showDebugger;
         }
      });
   },
   computed: {
      currency() {
         return this.response?.currency;
      },
      sortOptions() {
         return [
            { name: this.$t("rentacarSearch_sortPriceAsc"), value: "priceAsc" },
            { name: this.$t("rentacarSearch_sortPriceDesc"), value: "priceDesc" },
         ];
      },
      Cars() {
         const vehicles = this.response?.vehicles;
         if (!vehicles) return null;

         const vehiclesArray = Object.keys(vehicles).map((key) => vehicles[key]);

         if (this.sortBy === "priceAsc") {
            return vehiclesArray.sort((a, b) => a.totalPrice - b.totalPrice);
         } else if (this.sortBy === "priceDesc") {
            return vehiclesArray.sort((a, b) => b.totalPrice - a.totalPrice);
         }

         return vehiclesArray;
      },
   },
   methods: {
      handlerSelection(selectionUuid) {
         this.handlerGenerateCars();
         this.$set(this.response.vehicles[selectionUuid], "selected", true);
      },
      handlerSearchResponse(response) {
         this.response = this.selection = this.selection = null;

         const self = this;
         // setTimeout(() => {

         // }, 10);
         self.response = response;
         this.handlerGenerateCars();
      },
      handlerFilters(filters) {
         this.filters = filters;
      },
      handlerGenerateCars() {
         if (this.response?.vehicles) {
            Object.keys(this.response.vehicles).forEach((vehicleUuid) => {
               this.$set(this.response.vehicles[vehicleUuid], "selected", false);
               this.$set(this.response.vehicles[vehicleUuid], "showAncillaries", false);
            });
         }
      },
      handlerUnselectAll() {
         Object.keys(this.response.vehicles).forEach((vehicle) => {
            this.response.vehicles[vehicle].selected = false;
            this.response.vehicles[vehicle].showAncillaries = false;
         });
      },
   },
   watch: {
      "$store.state.rentacar.isSearching": {
         handler: function (status) {
            if (status) {
               this.response = null;
            }
         },
      },
      selection: {
         handler: function (selection) {
            if (selection == null) {
               this.handlerUnselectAll();
            } else {
               this.isBasketActive = true;
            }
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
#rent-a-car-search-wrapper {
   .rent-a-car-sort {
      background-color: var(--container-bg);
      padding: 1rem;
      border-radius: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;

      @media (max-width: 576px) {
         margin-top: 1rem;
      }

      .sorting-wrapper {
         max-width: 300px;
      }

      .sorting-informations {
         font-weight: 500;
         white-space: nowrap;
      }
   }
}
</style>
